import React from "react";

import Image from "next/image";
import { GroqImage } from "@/helpers/Image";

import { PortableText } from "@portabletext/react";
import { customRichTextComponent } from "@/sanity/sanityPortableText";

import { PageManifestoSchema } from "@/sanity/pages/PageManifestoTemplate";

import sad from "@/public/manifesto/sad.svg";

export default function Problem({ data }: { data: PageManifestoSchema }) {
  return (
    <section className="pt-[2rem] lg:pt-[10rem] pb-[4rem] lg:pb-[9rem] overflow-clip">
      <div className="w-full max-w-[111rem] mx-auto px-[2rem] lg:px-0">
        {/*  */}
        <div className="w-full relative border-b-[.75rem] border-b-[#F97474]">
          <GroqImage
            src={data?.problemImage}
            alt="Problem image"
            className="w-full"
          />
          {/*  */}
          <div className="w-fit absolute bottom-0 left-0">
            <div className="w-fit flex justify-center items-center gap-[2rem] px-[4rem] pb-[1.5rem] pt-[2rem] bg-[#F97474] relative">
              {/* right bottom border */}
              <div
                className="absolute top-0 right-[-2.5rem] w-[5rem] h-full bg-[#F97474]"
                style={{
                  clipPath: "polygon(50% 0%, 100% 50%, 100% 100%, 0 100%, 0 0)",
                }}
              ></div>
              {/* end right bottom border */}
              <Image
                src={sad}
                alt="Sad emoji"
                className="w-[2.5rem] min-w-[2.5rem]"
              />
              <span className="font-geist text-black text-[2rem] font-[400] leading-[100%] uppercase">
                {data?.settings?.language === "en" ? "The" : "Das"} Problem
              </span>
            </div>
          </div>
          {/*  */}
        </div>

        <div className="w-full bg-white p-[3rem] lg:p-[7rem]">
          {data?.problemTexts && (
            <PortableText
              value={data?.problemTexts ?? []}
              components={customRichTextComponent({
                block: {
                  h2: ({ children }) => (
                    <h2 className="font-funnel text-black text-[4.5rem] lg:text-[6rem] leading-[100%] font-[500] mb-[2rem]">
                      {children}
                    </h2>
                  ),
                  normal: ({ children }) => (
                    <p className="text-black/60 font-[400] leading-[150%] mb-0 text-[2.25rem]">
                      {children}
                    </p>
                  ),
                },
                marks: {
                  strong: ({ children }) => (
                    <span className="text-black">{children}</span>
                  ),
                },
              })}
            />
          )}
        </div>
      </div>
    </section>
  );
}
